

















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InputSearch extends Vue {
  @Prop({ default: false }) readonly showonly!: boolean;
  @Prop({ default: "200px" }) readonly width!: string;

  private showinput = false;
  private value = "";

  mounted() {
    if (this.showonly) {
      this.ToggleFocus();
      this.showinput = true;
    }
  }

  public ToggleFocus() {
    this.$nextTick(() => {
      const inputSearch: any = this.$refs.inputSearch;
      inputSearch.focus();
    });
  }
  public hide() {
    if (!this.value && !this.showonly) {
      this.showinput = false;
    }
  }
}
